// removed by extract-text-webpack-plugin
module.exports = {"error":"CohortDropdown__error___11tdP"};